import styled from 'styled-components';

export const StyledMyPage = styled.div`
  .MuiBox-root {
    padding: 0 !important;
  }
`;
